<div class="page-wrapper">
  <app-edgar-info-summary
    [html]="(companyFacade.edgarHtml$ | async)!"
    [summary]="(companyFacade.forecast$ | async)?.summary ?? ''"
    (getReport)="getReport()"
  ></app-edgar-info-summary>
</div>

@if (companyFacade.inRequest$ | async) {
  <div class="app-loading-wrapper">
    <app-loading></app-loading>
  </div>
}
